import { GET_STAFF_LIST } from "./staffTypes"

export default {
  [GET_STAFF_LIST](state, data) {
    data.unshift({ user_id: -1, name: "Any staff" });
    state.staffList = data;
  },
}
